import { LoadState } from "../../../constants/enums";
import { initialAutomobileApplicationState } from "../../automobileApplication/automobileApplication.types";
import { initialAutomobileAlbertaApplicationState } from "../../automobileAlbertaApplication/automobileAlbertaApplication.types";
import { ILeadAutoApplicationState } from "./leadAutoApplication.types";

export const initialLeadAutoApplicationState: ILeadAutoApplicationState = {
  data_on: initialAutomobileApplicationState["application_on"]["application"],
  data_ab: initialAutomobileAlbertaApplicationState.application,
  activeSubType: "on",
  loading: LoadState.NotLoaded,
};
